

















import {Component} from "vue-property-decorator";
import {UserLevel} from "shared/entities/user";
import * as icons from "@fortawesome/free-solid-svg-icons";
import {orderBy} from "lodash";
import AuthMixin from "@/mixins/auth.mixin";
import {Api} from "shared/api";
import {IBrandManual} from "shared/entities/brand-manual";
import {apiHandler} from "@/services/api-handler";

@Component({})
export default class BrandManualSection extends AuthMixin {
    UserLevel = UserLevel;
    icons = icons;
    brandManuals: IBrandManual[] = [];

    get orderedBrandManuals(): IBrandManual[] {
        return orderBy(this.brandManuals, ["order"]);
    }

    async mounted() {
        this.brandManuals = await apiHandler(() => Api.brandManual.Get());
    }
}

